jQuery(document).ready(function($) {

    var $container = $('.articles');

    if (!$container.length) {
        console.warn('News AJAX: container not found');
        return;
    }

    var currentPage = 1;
    var currentCats = '';

    var ajaxUrl = $container.data('ajax-url');

    function loadActualites(params) {
        params = params || {};

        if (params.paged !== undefined) {
            currentPage = params.paged;
        }

        if (params.cat !== undefined) {
            currentCats = params.cat;
        }

       

        $.ajax({
            url: ajaxUrl,
            method: 'POST',
            data: {
                action: 'load_actualites',
                paged: currentPage,
                cat: currentCats
            },
            dataType: 'json',
            success: function(response) {
                $container.html(response.articles).css('opacity', 0);
                $container.animate({ opacity: 1 }, 300, function() {
                    $('html, body').animate({ scrollTop: $container.offset().top - 200 }, 500);
                });

                var $pagination = $('#pagination-wrapper');
                if ($pagination.length) {
                    $pagination.html(response.pagination);
                }

            },
            error: function(xhr, status, error) {
                console.error('News AJAX error:', error);
            }
        });
    }

    // ===== FILTERS =====
    $(document).on('click', '.filters a.button--filter', function(e) {
        e.preventDefault();

        const $clicked = $(this);
        const $filters = $('.filters a.button--filter');
        const $allBtn  = $filters.first(); 

        if ($clicked.is($allBtn)) {
            $filters.removeClass('button--filter-active');
            $allBtn.addClass('button--filter-active');

            loadActualites({
                cat: '',
                paged: 1
            });
            return;
        }

        $allBtn.removeClass('button--filter-active');
        $clicked.toggleClass('button--filter-active');

        let cats = [];
        $('.filters a.button--filter-active').not($allBtn).each(function() {
            const cat = $(this).data('cat');
            if (cat) cats.push(cat);
        });

        if (!cats.length) {
            $allBtn.addClass('button--filter-active');
        }

        loadActualites({
            cat: cats.join(','),
            paged: 1
        });
    });

    // ===== PAGINATION =====
    $(document).on('click', '.pagination a.page-numbers:not(.next):not(.prev)', function(e) {
        e.preventDefault();

        var paged = parseInt($(this).text(), 10) || 1;

        loadActualites({
            paged: paged
        });
    });


    // ===== PAGINATION ARROWS =====
    $(document).on('click', '.pagination a.next, .pagination a.prev', function(e) {
        e.preventDefault();

        var paged = currentPage;

        if ($(this).hasClass('next')) paged++;
        if ($(this).hasClass('prev')) paged--;

        paged = Math.max(1, paged);

        loadActualites({
            paged: paged
        });
    });

});


